import {
    userInfo
} from "os";
import http from "@/lib/http";
export const formCommonMixins = {
    data() {
        return {}
    },
    methods: {
        getFormData() {
            console.log("getPFormData", this.pType);
            let myself = this;
            this.globalData = {};
            http.get("getPFormData/" + this.pType, {}, (error, callback) => {
                if (callback.length > 0)
                    this.globalData = callback;
                console.log("GlobalDATA", this.globalData);
                for (var i in callback) {
                    console.log("Callback i", i);
                    myself[i] = callback[i];
                    // myself.globalData = callback.data[0];                    
                    //TODO:: add company updates into our array in future
                }
                myself.setData();
                myself.setFormData();
                console.log("myself", this.globalData);
            });
        },
        setCommonData() {
            this.fields = [];
            // console.log("Data SEt");
            var frmFields = Object.keys(this.globaldata);
            // console.log(Object.keys(this.globaldata), Object.keys(this.globaldata[frmFields[0]]));
            if (this.pType === 'p1') {
                frmFields.forEach((val, key) => {
                    console.log(val, typeof this.globaldata[val]);
                    if (val !== '_id' && val !== 'type' && val !== 'status' && val !== 'msg' && val !== 'update') {
                        if (typeof this.globaldata[val] === 'object') {
                            var f = {
                                label: this.getLabel(val),
                                name: val,
                                type: "text",
                                sort_order: key,
                                reletedField: [{
                                        label: this.getLabel(val) + " S",
                                        placeholder: "Enter S",
                                        name: val + "_s",
                                        type: "text",
                                        value: this.globaldata[val] ?
                                            this.globaldata[val].S : this.defaultSrc
                                    },
                                    {
                                        label: this.getLabel(val) + " Weight",
                                        placeholder: "Enter Date",
                                        name: val + "_weight",
                                        type: "text",
                                        value: this.globaldata[val] ? this.globaldata[val].W : ""
                                    }
                                ]
                            }
                        } else {
                            var f = {
                                label: this.getLabel(val),
                                name: val,
                                type: "text",
                                value: this.globaldata[val],
                                reletedField: [],
                                sort_order: 9999,
                            }
                        }
                        this.fields.push(f);
                    }
                });
            } else if(this.pType === 's1'){
                frmFields.forEach((val, key) => {
                    console.log(val, typeof this.globaldata[val]);
                    if (val !== '_id' && val !== 'type' && val !== 'status' && val !== 'msg' && val !== 'update') {
                        if (typeof this.globaldata[val] === 'object') {
                            var f = {
                                label: this.getLabel(val),
                                name: val,
                                type: "text",
                                sort_order: key,
                                reletedField: [{
                                        label: this.getLabel(val) + " Benchmark",
                                        placeholder: "Enter Benchmark",
                                        name: val + "_benchmark",
                                        type: "text",
                                        value: this.globaldata[val] ?
                                            this.globaldata[val].benchmark : ''
                                    }
                                ]
                            }
                        } else {
                            var f = {
                                label: this.getLabel(val),
                                name: val,
                                type: "text",
                                reletedField: [],
                                value: this.globaldata[val],
                                sort_order: 9999
                            }                            
                        }
                        this.fields.push(f);
                    }
                });
            } else {
                frmFields.forEach((val, key) => {
                    // console.log(val, typeof this.globaldata[val]);
                    if (val !== '_id' && val !== 'type' && val !== 'status' && val !== 'msg' && val !== 'update') {
                        
                        if (val === "Banks" || val === "Finance") {
                            var subFields = [];
                            var frmSubFields = Object.keys(this.globaldata[val]);
                            frmSubFields.forEach((val1, key1) => {
                              if (typeof this.globaldata[val][val1] === "object") {
                                var f = {
                                  label: this.getLabel(val1),
                                  name: val1,
                                  type: "text",
                                  sort_order: key,
                                  reletedField: [
                                    {
                                      label: this.getLabel(val1) + " Benchmark",
                                      placeholder: "Enter Benchmark",
                                      name: val + "_benchmark",
                                      type: "text",
                                      value: this.globaldata[val1]
                                        ? this.globaldata[val1].benchmark
                                        : ""
                                    },
                                    {
                                      label: this.getLabel(val1) + " Weight",
                                      placeholder: "Enter Weight",
                                      name: val + "_weight",
                                      type: "text",
                                      value: this.globaldata[val1]
                                        ? this.globaldata[val1].weight
                                        : ""
                                    }
                                  ]
                                };
                              } else {
                                var f = {
                                  label: this.getLabel(val1),
                                  name: val1,
                                  type: "text",
                                  reletedField: [],
                                  value: this.globaldata[val1],
                                  sort_order: 9999
                                };
                              }
                              subFields.push(f);
                            });
                            if (val === "Banks") this.fields.push({ Banks: subFields });
                            else if (val === "Finance") this.fields.push({ Finance: subFields });
                          }else {
                              console.log(val);
                        if (typeof this.globaldata[val] === 'object') {
                            var f = {
                                label: this.getLabel(val),
                                name: val,
                                type: "text",
                                sort_order: key,
                                reletedField: [{
                                        label: this.getLabel(val) + " Benchmark",
                                        placeholder: "Enter Benchmark",
                                        name: val + "_benchmark",
                                        type: "text",
                                        value: this.globaldata[val] ?
                                            this.globaldata[val].benchmark : ''
                                    },
                                    {
                                        label: this.getLabel(val) + " Weight",
                                        placeholder: "Enter Weight",
                                        name: val + "_weight",
                                        type: "text",
                                        value: this.globaldata[val] ? this.globaldata[val].weight : ""
                                    }
                                ]
                            }
                        } else {
                            var f = {
                                label: this.getLabel(val),
                                name: val,
                                type: "text",
                                reletedField: [],
                                value: this.globaldata[val],
                                sort_order: 9999
                            }                            
                        }
                        this.fields.push(f);
                    }
                    }
                });
            }
            this.fields = this.sorted_fields_asc(this.fields, 'sort_order');
            console.log("new Fields", this.fields);
        },
        setFormData() {
            console.log("SET Form");
            this.formData = {};
            for (var index in this.fields) {
                let field = this.fields[index];
                if (!field.placeholder) field.placeholder = "";
                if (!field.value) field.value = "";
                if (!field.help) field.help = "";
                this.$set(this.formData, field.name, field.value);
                if (field.reletedField && field.reletedField.length > 0) {
                    let relatedData = field.reletedField;
                    for (var ind in relatedData) {
                        let field1 = relatedData[ind];
                        if (!field1.placeholder) field1.placeholder = "";
                        if (!field1.value) field1.value = "";
                        if (!field1.help) field1.help = "";
                        if (!field1.type) field1.type = "";
                        this.$set(this.formData, field1.name, field1.value, field1.type);
                    }
                }
            }
            // console.log("this.formData", this.formData);
        },
        getData() {
            console.log(this.globaldata);
            let data = {};
            for (let fd in this.fields) {
                let field = this.fields[fd];
                console.log("Field", field.name, typeof this.globaldata[field.name], this.globaldata[field.name]);
                if (typeof this.globaldata[field.name] === 'object') {
                    this.globaldata[field.name] = {
                        S: "",
                        W: ""
                    };
                    console.log("getFormdata", this.globaldata[field.name].S, this.formData[field.name + "_s"]);
                    // this.globalData[field.name].value = this.formData[field.name];
                    this.globaldata[field.name].S = this.formData[field.name + "_s"];
                    this.globaldata[field.name].W = this.formData[field.name + "_weight"];
                } else {
                    this.globaldata[field.name] = this.formData[field.name];
                }
            }
            console.log("Global Data" + this.globaldata, JSON.stringify(this.globaldata));
        },
        submitP1: function (formData) {
            let myself = this;
            console.log("submit form", this.formData, this.globaldata);
            this.getData();
            var t = this.pType;
            var data = {};
            data = {
                p1: this.globaldata
            };
            console.log(this.pType, data);
            http.post("updatePFormData", data, (error, callback) => {
                // myself.$router.push({ name: "settings" });
                //TODO:: add company updates into our array in future
                this.$toastr.success("Updated Successfully!", "", {});
            });
        },
        getS1Data() {
            console.log(this.globaldata);
            let data = {};
            for (let fd in this.fields) {
                let field = this.fields[fd];
                console.log("Field", field.name, typeof this.globaldata[field.name], this.globaldata[field.name]);
                if (typeof this.globaldata[field.name] === 'object') {
                    this.globaldata[field.name] = {
                        benchmark: ""
                    };
                    console.log("getFormdata", this.globaldata[field.name].S, this.formData[field.name + "_benchmark"]);
                    // this.globalData[field.name].value = this.formData[field.name];
                    this.globaldata[field.name].benchmark = this.formData[field.name + "_benchmark"];
                } else {
                    this.globaldata[field.name] = this.formData[field.name];
                }
            }
            console.log("Global Data" + this.globaldata, JSON.stringify(this.globaldata));
        },
        submitS1: function (formData) {
            let myself = this;
            console.log("submit form", this.formData, this.globaldata);
            this.getS1Data();
            var t = this.pType;
            var data = {};
            data = {
                s1: this.globaldata
            };
            console.log(this.pType, data);
            http.post("updatePFormData", data, (error, callback) => {
                // myself.$router.push({ name: "settings" });
                //TODO:: add company updates into our array in future
                this.$toastr.success("Updated Successfully!", "", {});
            });
        },
        getBenchmarkAndWeightData() {
            console.log(this.globaldata);
            let data = {};
            // this.globalData = [];
            for (let fd in this.fields) {
                let field = this.fields[fd];
                console.log("Field", field.name);
                if (typeof this.globaldata[field.name] === 'object') {
                    this.globaldata[field.name] = {
                        benchmark: "",
                        weight: ""
                    };
                    // this.globalData[field.name].value = this.formData[field.name];
                    this.globaldata[field.name].benchmark = this.formData[
                        field.name + "_benchmark"
                    ];
                    this.globaldata[field.name].weight = this.formData[
                        field.name + "_weight"
                    ];
                } else {
                    this.globaldata[field.name] = this.formData[field.name];
                }
            }
            console.log("Global Data" + this.globaldata);
        },
        submitPBenchmarkAndWeight: function (formData) {
            let myself = this;
            console.log("submit form", this.formData);
            this.getBenchmarkAndWeightData();
            var data = {};
            if (this.pType === 'p2') data = {
                p2: this.globaldata
            };
            else if (this.pType === 'p3') {
                data = {
                    p3: this.globaldata
                };
            } else if (this.pType === 'p4') {
                data = {
                    p4: this.globaldata
                };
            } else if (this.pType === 'p5A') {
                data = {
                    p5A: this.globaldata
                };
            } else if (this.pType === 'p5B') {
                data = {
                    p5B: this.globaldata
                };
            } else if (this.pType === 'p6A') {
                data = {
                    p6A: this.globaldata
                };
            } else if (this.pType === 'p6B') {
                data = {
                    p6B: this.globaldata
                };
            } else if (this.pType === 'p7A') {
                data = {
                    p7A: this.globaldata
                };
            } else if (this.pType === 'p7B') {
                data = {
                    p7B: this.globaldata
                };
            } else if (this.pType === 'p8A') {
                data = {
                    p8A: this.globaldata
                };
            } else if (this.pType === 'p8B') {
                data = {
                    p8B: this.globaldata
                };
            } else if (this.pType === 'p10') {
                data = {
                    p10: this.globaldata
                };
            } else if (this.pType === 'p11') {
                data = {
                    p11: this.globaldata
                };
            } else if (this.pType === 'q1') {
                data = {
                    q1: this.globaldata
                };
            }
            console.log(this.pType, data);
            http.post("updatePFormData", data, (error, response) => {
                console.log("response", response);
                // myself.$router.push({ name: "settings" });
                //TODO:: add company updates into our array in future
                if (response.status === 'success') {
                    this.$toastr.success("Updated Successfully!", "", {});
                } else {
                    this.$toastr.error(response.status, "", {});
                }
            });
        },

        getGlobalFormData() {
            console.log("listManualDataApp", this.pType);
            let myself = this;
            http.get("listManualDataApp", {}, (error, callback) => {
                this.globalData = callback.data[0];
                for (var i in callback) {
                    console.log("Callback i", i);
                    myself[i] = callback[i];
                    // myself.globalData = callback.data[0];                    
                    //TODO:: add company updates into our array in future
                }
                myself.setData();
                myself.setFormData();
                console.log("myself", this.globalData);
            });
        },
        submitGlobalForm: function (formData) {
            let myself = this;
            console.log("submit form", this.formData);
            this.getGlobalData();
            http.post("updateManualDataApp", this.globalData, (error, callback) => {
                // myself.$router.push({ name: "settings" });
                //TODO:: add company updates into our array in future
                this.$toastr.success("Macro data updated successfully!", "", {});
            });
        },
        getGlobalData() {
            console.log(this.globalData);
            let data = {};
            for (let fd in this.fields) {
                let field = this.fields[fd];
                console.log("Field", field.name);
                this.globalData[field.name] = {
                    value: "",
                    source: "RBI",
                    Date: this.getDate(this.curDate)
                };
                this.globalData[field.name].value = this.formData[field.name];
                this.globalData[field.name].source = this.formData[
                    field.name + "_source"
                ];
                this.globalData[field.name].Date = this.formData[field.name + "_date"];
            }
            console.log("Global Data" + this.globalData, JSON.stringify(this.globalData));
        },
        getDate(d) {
            d = new Date(d);
            return d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();
        }
    },
    mounted() {}
}


// WEBPACK FOOTER //
// ./src/assets/mixins/formcommon.js